import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ShieldCheck, ClipboardCheck, Users, Mic, MessageSquareHeart, CalendarHeart, ArrowLeft, BarChart3, FileSignature, FileText } from "lucide-react";

const links = [
  { to: "/growing-circle/admin/verifications", label: "Verifications", icon: ClipboardCheck },
  { to: "/growing-circle/admin/users", label: "Users & Roles", icon: Users },
  { to: "/growing-circle/admin/content", label: "Content", icon: Mic },
  { to: "/growing-circle/admin/articles", label: "Articoli", icon: FileText },
  { to: "/growing-circle/admin/testimonials", label: "Testimonies", icon: MessageSquareHeart },
  { to: "/growing-circle/admin/meetings", label: "Meetings", icon: CalendarHeart },
  { to: "/growing-circle/admin/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/growing-circle/admin/acceptances", label: "Acceptances", icon: FileSignature },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-primary" />
            <span className="font-heading text-xl uppercase tracking-[0.14em]">Back office</span>
          </div>
          <button onClick={() => navigate("/growing-circle/member-area")} className="text-sm text-muted-foreground flex items-center gap-1 hover:text-foreground transition-colors" data-testid="back-to-space-btn">
            <ArrowLeft className="w-4 h-4" /> Back to the space
          </button>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 grid lg:grid-cols-[220px_1fr] gap-8">
        <nav className="flex lg:flex-col gap-1 overflow-x-auto">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`admin-nav-${l.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm whitespace-nowrap transition-colors ${
                  isActive ? "bg-secondary text-primary" : "text-muted-foreground hover:bg-secondary/50"
                }`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="animate-fade-in-up"><Outlet /></div>
      </div>
    </div>
  );
}
